export default __webpack_public_path__ + "static/media/venezuela.d1196af5.png";